import React, { useEffect, useRef } from "react";
import Map from "../../components/map";
import Listview from "../../components/listview";
import Header from "../../components/header";
import { getAllProjects } from "../../actions/data";
import { selectActivePage, selectMapType } from "../../reducers/";
import styles from "./root.module.scss";
import { connect } from "react-redux";
import ErrorBoundary from "./error-boundary";
import Loading from "../../components/loading";
import Popup from "../../components/popup";
import PropTypes from "prop-types";
import geometryConfig from "../../modules/geometryConfig";
import RegionSummaryPopup from "../../components/region-summary-popup";
import useComponentSize from "@rehooks/component-size";
import FullscreenButton from "../../components/fullscreen-button";

const Root = props => {
    const { mapType, getAllProjects, activePage } = props;
    const ref = useRef();
    const size = useComponentSize(ref);
    useEffect(() => {
        getAllProjects();
    }, []);
    return (
        <ErrorBoundary>
            <div
                data-container
                ref={ref}
                id="SMU_ROOT"
                className={styles.container}
            >
                {size.height === 0 ? (
                    <Loading />
                ) : (
                    <React.Fragment>
                        <Header
                            geometryConfig={geometryConfig[mapType]}
                            nameSelector={geometryConfig[mapType].nameSelector}
                        />
                        <Popup />
                        <RegionSummaryPopup
                            nameSelector={geometryConfig[mapType].nameSelector}
                        />
                        {activePage === "map" ? (
                            <Map
                                width={size.width}
                                height={size.height}
                                geometryConfig={geometryConfig[mapType]}
                            />
                        ) : (
                            <Listview />
                        )}
                        <FullscreenButton rootEl={ref.current} />
                    </React.Fragment>
                )}
            </div>
        </ErrorBoundary>
    );
};
const mapStateToProps = state => ({
    activePage: selectActivePage(state),
    mapType: selectMapType(state),
});

Root.propTypes = {
    getAllProjects: PropTypes.func.isRequired,
    mapType: PropTypes.string.isRequired,
    activePage: PropTypes.string,
};
const mapDispatchToProps = { getAllProjects };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root);



// WEBPACK FOOTER //
// ./src/pages/root/root.js